export default {
    0: {
        submit: '提交',
        predict: '立即分析',
        modify: '修改分析',
        noModifyChance: '暂无修改次数',
        yourPrediction: '您的分析',
        predictAction: '分析',
        pricePlaceholder: '请输入',
        closePrice: '收盘价',
        submitted: '已提交',
        submitFailed: '提交失败，请重试',
        roundEnded: '本轮分析已结束',
        nextRound: '下一轮',
        ended: '已结束',
        pendingDraw: '待开奖',
        higherThanCurrent: '高于现价',
        lowerThanCurrent: '低于现价',
        equalToCurrent: '等于现价',
        reasonTitle: '理由',
        reasonPlaceholder: '请输入您的判断依据',
        // 说明：用于“参与统计”里仅高亮“上涨/下跌”两个词
        statUpWord: '上涨',
        statDownWord: '下跌',
        upDownTitle: '猜涨跌',
        upText: '涨',
        downText: '跌',
        submittingText: '提交中...',
        submitGuess: '提交',
        modifyGuess: '提交修改',
        yourGuessLabel: '您的竞猜：',
        watchedAdded: '已添加自选',
        watchedRemoved: '已取消自选',
        // 说明：使用方案 B（模板插值），避免 prefix/suffix 拼接
        // - {date}: 结算日
        // - {stock}: 标的名称（用于高亮显示，模板中只应出现一次）
        closePriceTitleTpl: '您分析{date}{stock}收盘价是？',
        // 说明：结算后且猜中时标题文案（{stock} 用于高亮显示）
        prophetCongratsTpl: '恭喜您 成为本轮{stock}预言家！',
        // 说明：结算后且猜中时，参与统计位置展示“打败 xx% 的人”（{percent} 需要高亮）
        beatPeopleTpl: '您打败了 {percent} 的人',
        // 说明：结算后且猜中时，前置展示参与人数（{count} 为人数，包含分隔标点；文案不含“已有”）
        participateCountPrefixTpl: '{count}人参与，',
        // 说明：参与统计（{trend} 需要单独高亮）
        statTextTpl: '已有{count}人参与，{pct}%的牛友认为会{trend}'
    },
    // 繁体版
    1: {
        submit: '提交',
        predict: '立即分析',
        modify: '修改分析',
        noModifyChance: '暂無修改次數',
        yourPrediction: '您的分析',
        predictAction: '分析',
        pricePlaceholder: '請輸入',
        closePrice: '收盤價',
        submitted: '已提交',
        submitFailed: '提交失敗，請重試',
        roundEnded: '本輪分析已結束',
        nextRound: '下一輪',
        ended: '已結束',
        pendingDraw: '待開獎',
        higherThanCurrent: '高於現價',
        lowerThanCurrent: '低於現價',
        equalToCurrent: '等於現價',
        reasonTitle: '理由',
        reasonPlaceholder: '請輸入您的判斷依據',
        // 说明：用于“参与统计”里仅高亮“上漲/下跌”两个词
        statUpWord: '上漲',
        statDownWord: '下跌',
        upDownTitle: '猜漲跌',
        upText: '漲',
        downText: '跌',
        submittingText: '提交中...',
        submitGuess: '提交',
        modifyGuess: '提交修改',
        yourGuessLabel: '您的競猜：',
        watchedAdded: '已添加自選',
        watchedRemoved: '已取消自選',
        // 说明：使用方案 B（模板插值），避免 prefix/suffix 拼接
        // - {date}: 結算日
        // - {stock}: 標的名稱（用於高亮顯示，模板中只應出現一次）
        closePriceTitleTpl: '您分析{date}{stock}收盤價是？',
        // 说明：結算後且猜中時標題文案（{stock} 用於高亮顯示）
        prophetCongratsTpl: '恭喜您 成為本輪{stock}預言家！',
        // 说明：結算後且猜中時，參與統計位置展示“打敗 xx% 的人”（{percent} 需要高亮）
        beatPeopleTpl: '您打敗了 {percent} 的人',
        // 说明：結算後且猜中時，前置展示參與人數（{count} 為人數，包含分隔標點；文案不含“已有”）
        participateCountPrefixTpl: '{count}人參與，',
        // 说明：參與統計（{trend} 需要單獨高亮）
        statTextTpl: '已有{count}人參與，{pct}%的牛友認爲會{trend}'
    },
    // 英文版
    2: {
        submit: 'submit',
        predict: 'Analyze Now',
        modify: 'Modify Analysis',
        noModifyChance: 'No Modify Chance',
        yourPrediction: 'Your analysis',
        predictAction: 'Analyze',
        pricePlaceholder: 'Please enter',
        closePrice: 'Close Price',
        submitted: 'Submitted',
        submitFailed: 'Submit Failed, Please Try Again',
        roundEnded: 'This analysis round has ended',
        nextRound: 'Next round',
        ended: 'Ended',
        pendingDraw: 'Pending draw',
        higherThanCurrent: 'Above current',
        lowerThanCurrent: 'Below current',
        equalToCurrent: 'Same as current',
        reasonTitle: 'Reason',
        reasonPlaceholder: 'Please enter your rationale',
        // 说明：用于“参与统计”里仅高亮趋势词
        statUpWord: 'rise',
        statDownWord: 'fall',
        upDownTitle: 'Up/Down',
        upText: 'Up',
        downText: 'Down',
        submittingText: 'Submitting...',
        submitGuess: 'Submit',
        modifyGuess: 'Submit changes',
        yourGuessLabel: 'Your guess:',
        watchedAdded: 'Added to watchlist',
        watchedRemoved: 'Removed from watchlist',
        // 说明：使用方案 B（模板插值），避免 prefix/suffix 拼接
        // - {date}: settle date
        // - {stock}: stock name (should appear only once, for highlighting)
        closePriceTitleTpl: 'Analyze {date} {stock} Close Price?',
        // 说明：结算后且猜中时标题文案（{stock} 用于高亮显示）
        prophetCongratsTpl: "Congrats! You're this round's {stock} Prophet!",
        // 说明：结算后且猜中时，参与统计位置展示“打败 xx% 的人”（{percent} 需要高亮）
        beatPeopleTpl: 'You beat {percent} of people',
        // 说明：结算后且猜中时，前置展示参与人数（{count} 为人数，包含分隔标点）
        participateCountPrefixTpl: '{count} people joined, ',
        // 说明：参与统计（{trend} 需要单独高亮）
        statTextTpl: 'Joined by {count} people, {pct}% think it will {trend}'
    }
};
